import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { GetMyPassengerResponse } from '../../types/auth.js'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

export const useDeleteMyPassengerMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (passengerId: string) => {
      await apiClient.client.delete(`/me/passengers/${passengerId}`)
    },
    onError: () => {
      void queryClient.invalidateQueries({ queryKey: meKeys.passengers })
    },
    onMutate: async (passengerId) => {
      await queryClient.cancelQueries({ queryKey: meKeys.passengers })

      const previousPassengers = queryClient.getQueryData<GetMyPassengerResponse[]>(
        meKeys.passengers
      )

      if (previousPassengers) {
        queryClient.setQueryData<GetMyPassengerResponse[]>(
          meKeys.passengers,
          previousPassengers.filter((p) => p.id !== passengerId)
        )
      }

      return { previousPassengers }
    },
  })
}
